export enum CustomFieldType {
  TEXT = "TEXT",
  TEXTAREA = "TEXTAREA",
  NUMBER = "NUMBER",
  DATE = "DATE",
  DROPDOWN = "DROPDOWN",
  CHECKBOX = "CHECKBOX",
}
